export default __webpack_public_path__ + "static/media/pc_background2@3x.3e8b1fd3.png";